import React, { useMemo } from "react";
import { useLocale } from "~/core/useLocale";

export const DateFormat = ({
  date,
  format,
}: {
  date: Date;
  format: Intl.DateTimeFormatOptions;
}) => {
  const locale = useLocale();

  const formattedDate = useMemo(
    () => date.toLocaleDateString(locale, format),
    [date, format, locale],
  );

  return <>{formattedDate}</>;
};

export const TimeFormat = ({
  date,
  format,
}: {
  date: Date;
  format: Intl.DateTimeFormatOptions;
}) => {
  const locale = useLocale();

  const formattedDate = useMemo(
    () => date.toLocaleTimeString(locale, format),
    [date, format, locale],
  );

  return <>{formattedDate}</>;
};
